import React from "react";
import About from "../../components/about";
import Portfolio from "../../components/portfolio";

const AboutPage = () => {

    return (
        <div>
            <About />
            <Portfolio />
        </div>
    );
}

export default AboutPage;